// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"styles_actionButton__1fD9A","stepTwoButton2":"styles_stepTwoButton2__184-7","quitBlock2":"styles_quitBlock2__2JZDg"};